































import { Component, Prop } from "vue-property-decorator";

import { VFlex } from "vuetify/lib";
import {
  DialogSection,
  DialogForm,
  FormSelect
} from "sitewhere-ide-components";

import {
  ICommandDestinationGenericConfiguration,
  IDeviceTypeMapping
} from "sitewhere-configuration-model";
import { IDeviceType } from "sitewhere-rest-api";

import { required } from "vuelidate/lib/validators";

@Component({
  components: { VFlex, DialogSection, DialogForm, FormSelect },
  validations: {
    deviceType: {
      required
    },
    destination: {
      required
    }
  }
})
export default class MappingsFields extends DialogSection {
  @Prop() readonly destinations!: ICommandDestinationGenericConfiguration[];
  @Prop() readonly deviceTypes!: IDeviceType[];

  deviceType: string | null = null;
  destination: string | null = null;

  /** Reset section content */
  reset(): void {
    this.deviceType = null;
    this.destination = null;
    this.$v.$reset();
  }

  /** Perform validation */
  validate(): boolean {
    this.$v.$touch();
    return !this.$v.$invalid;
  }

  /** Load form data from an object */
  load(input: IDeviceTypeMapping): void {
    this.deviceType = input.deviceTypeToken;
    this.destination = input.destinationId;
  }

  /** Save form data to an object */
  save(): IDeviceTypeMapping {
    return {
      deviceTypeToken: this.deviceType || "",
      destinationId: this.destination || ""
    };
  }
}
